import { effect, Injectable, OnDestroy, Signal, signal, WritableSignal } from '@angular/core';
import { ApiService, AuthService, ErrorResponse } from '@toteimlib/angular-lib';
import { Organization } from 'app/models/organization';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService implements OnDestroy {

  private organization: WritableSignal<Organization | null> = signal(null);

  private readonly storageHandler: (event: StorageEvent) => void;
  private isStorageListenerSet: boolean = false;

  constructor(private userService: UserService, private authService: AuthService, private apiService: ApiService) {
    const organization: string | null = localStorage.getItem('organization');
    const token: Signal<string | null> = this.authService.getToken();

    if (organization) {
      this.setOrganization(JSON.parse(organization));
    }

    // Listen to localStorage changes from other tabs
    this.storageHandler = (event: StorageEvent): void => {
      if (event.key === 'organization') {
        if (!event.newValue || event.newValue === '') {
          this.removeOrganization();
        }
        else if (event.newValue && event.newValue !== event.oldValue) {
          this.setOrganization(JSON.parse(event.newValue));
        }
      }
    };

    effect((): void => {
      if (token() && !this.isStorageListenerSet) {
        window.addEventListener('storage', this.storageHandler);
        this.isStorageListenerSet = true;
      }
      else if (!token() && this.isStorageListenerSet) {
        window.removeEventListener('storage', this.storageHandler);
        this.isStorageListenerSet = false;
      }
    });
  }

  ngOnDestroy(): void {
    window.removeEventListener('storage', this.storageHandler);
    this.isStorageListenerSet = false;
  }

  setOrganization(organization: Organization): void {
    if (organization) {
      if (organization.menu) {
        localStorage.setItem('organization', JSON.stringify(organization));
        localStorage.setItem('organization_id', organization.id);

        this.userService.reloadUser();
        this.organization.set(organization);
      }
      else {
        this.apiService.post('organization', {
          organization_id: organization.id
        }, (res: any): void => {
          const organization: Organization = res.data;

          localStorage.setItem('organization', JSON.stringify(organization));
          localStorage.setItem('organization_id', organization.id);

          this.userService.reloadUser();
          this.organization.set(organization);
        },  (_: ErrorResponse): void => {
          this.removeOrganization();
        });
      }
    }
    else {
      this.removeOrganization();
    }
  }

  getOrganization(): Signal<Organization | null> {
    return this.organization;
  }

  removeOrganization(): void {
    localStorage.removeItem('organization');
    localStorage.removeItem('organization_id');
    this.organization.set(null);
  }

}
